// Matches the Producers header of the "Download Data" export (`CsvExportHeaders.ProducersHeader` in
// eid-insurance), the only file bulk import reads producers from.
export const PRODUCERS_COLUMN_LABEL = 'Producers';
